import React from "react";
import { useParams } from "react-router-dom";
import status from "../../../../assets/img/admin/res/reserve.svg";
import useFetch from "../../../../hooks/useAxios";
import Button from "../../../shared/Button";
const AdminResidencesStatus = ({ inforesidencedetail,apiGetresidencedetailInfo }) => {
  const { code } = useParams();
  const verifiedPost = useFetch({
    method: "post",
    url: `api/admin/residences/verify/${code}`,
    noHeader: false,
    trigger: false,
caller:apiGetresidencedetailInfo,
    argFunc: res => {}
  });
  const unverifiedPost = useFetch({
    method: "post",
    url: `api/admin/residences/un-verify/${code}`,
    noHeader: false,
    trigger: false,
    caller:apiGetresidencedetailInfo,

    argFunc: res => {}
  });
  const onChangevarified = () => {
    verifiedPost.reFetch();
  };
  const onChangeunvarified = () => {
    unverifiedPost.reFetch();
  };
  return (
    <div className="AdminResidencesStatus flex gap-[8px] items-center justify-center">
      <img src={status} />
      {inforesidencedetail.status === "verified"
        ? <p className="text-[20px] text-[#00A6A6] font-[500]">
             تایید شده
          </p>
        : inforesidencedetail.status === "pending"
          ? <p className="text-[20px] text-[#dbbf4f] font-[500]">
                درحال انتظار
            </p>
          : <p className="text-[20px] text-[#F11F1F] font-[500]">
                تایید نشده
            </p>}

      <div className="">
        {inforesidencedetail.status === "pending"
          ? <div className="grid grid-cols-2 gap-[20px]">
              {" "}<Button onClick={onChangevarified} fullwidth varient="primary" >تایید</Button>
              <Button
                fullwidth
                varient="secondary" onClick={onChangeunvarified}
              >
                رد
              </Button>
            </div>
          : inforesidencedetail.status === "verified"
            ? <Button onClick={onChangeunvarified} fullwidth varient="secondary">
                رد
              </Button>
            : <Button onClick={onChangevarified} fullwidth varient="secondary">
                تایید
              </Button>}
      </div>
    </div>
  );
};

export default AdminResidencesStatus;
